import { t } from '@/core/i18n'

const API_URL = '/v1.0/management/Grades'

const MODULE_TITLE = t('list-of-grades')

const NAME = 'grades'


export const allowedSortBy = ["Id", "EnglishName", "ArabicName", "Number"];

const settings: AppContainerSettings = {
  hasView: true,
  hasExport: true,
  hasBlock: false,
  hasDelete: true,
  hasNotify: false,
  hasFilter: true,
  hasSearch: true,
  hasEdit: true,
  rowsOptions: {
    hasView: true,
    hasBlock: false,
    hasDelete: false,
    hasEdit: false,
  },
}



const tableHeader: LabelVal[] = [
  {
    label: 'id',
    value: 'id',
  },
  {
    label: t('grade-ar'),
    value: 'nameArabic',
  },
  {
    label: t('grade-en'),
    value: 'name',
  },
  {
    label: t('number-of-subjects-linked'),
    value: 'noOfSubjects',
  },
  {
    label: t('number-of-users-students'),
    value: 'noOfStudents',
  },
  {
    label: t('action'),
    value: 'Action',
  },
]

export default {
  API_URL,
  settings,
  tableHeader,
  NAME,
  MODULE_TITLE,
}
